export default __webpack_public_path__ + "img/3d516b3577b05445a357aeee9ece1fdf.svg";